import { render, staticRenderFns } from "./AnnouncementEditorPage.vue?vue&type=template&id=0c2dd875&scoped=true&"
import script from "./AnnouncementEditorPage.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEditorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dd875",
  null
  
)

export default component.exports